import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TrCheckboxModule } from "@toro/common/shared/components";
import { DialogsService } from "@toro/common/shared/services/dialogs.service";
import { TrackingsService } from "../../../services/tracking.service";
import { CheckoutSuitabilityDisclaimerComponent } from './checkout-suitability-disclaimer.component';

@NgModule({
    imports: [
        CommonModule,
        TrCheckboxModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
      CheckoutSuitabilityDisclaimerComponent,
    ],
    exports: [CheckoutSuitabilityDisclaimerComponent],
    providers: [
      DialogsService,
      TrackingsService,
    ]
})

export class CheckoutSuitabilityDisclaimerModule {}
